import { Box, BoxProps, Heading, VStack } from '@chakra-ui/react';
import * as React from 'react';

interface FinancialsPageProps {
  children: React.ReactNode;
  title?: string;
}

export const FinancialsPage: React.FC<FinancialsPageProps> = ({
  children,
  title = 'Financials'
}) => {
  return (
    <Box>
      {children}
    </Box>
  );
};

export default FinancialsPage;
